import { styled } from 'baseui'
import { FlexColumn } from '@/shared/theme/styled-components'

export const ModalLayout = styled(FlexColumn, {
  gap: '1.5rem',
  padding: '1rem 0 1.5rem 0',
})

export const Title = styled('h2', ({ $theme }) => ({
  fontSize: '1.0625rem',
  fontWeight: '600',
  color: $theme.colors.textBody,
  marginBottom: '0.25rem',
}))

export const Subtitle = styled('p', ({ $theme }) => ({
  fontSize: '0.875rem',
  color: $theme.colors.textSecondaryAlt,
  lineHeight: '1.4',
  marginTop: 0,
  marginBottom: '0.75rem',
}))

export const CheckboxGroup = styled(FlexColumn, {
  gap: '0.75rem',
})

export const QuestionText = styled('p', ({ $theme }) => ({
  fontSize: '0.875rem',
  fontWeight: 500,
  color: $theme.colors.textBody,
  margin: '0.75rem 0 0.25rem',
}))

export const FeedbackButtonsRow = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  gap: '1rem',
  width: '100%',
})

export const FeedbackButton = styled('button', ({ $theme, $active }) => ({
  flex: 1,
  padding: '0.75rem 0',
  borderRadius: '0.5rem',
  border: `0.0625rem solid ${$theme.colors.borderMedium}`,
  backgroundColor: $active ? $theme.colors.bgHover : $theme.colors.white,
  color: $theme.colors.textBody,
  fontSize: '0.875rem',
  fontWeight: 500,
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '0.5rem',
}))

export const SuccessContainer = styled(FlexColumn, {
  alignItems: 'center',
  gap: '2rem',
  paddingTop: '2rem',
  paddingBottom: '1rem',
})

export const SuccessMessage = styled('p', ({ $theme }) => ({
  fontSize: '1.125rem',
  fontWeight: '600',
  color: $theme.colors.successAlt,
  lineHeight: '1.5rem',
  textAlign: 'center',
  marginTop: '1rem',
}))
